type param = number | string

// Practices or Tests routes
export const resource = (type: string) => ({
  index: `/lessons/${type}`,
  options: `/lessons/${type}/options`,
  new: `/lessons/${type}/new`,
  new_auto: `/lessons/${type}/new-autogenerated`,
  edit: (id: param) => `/lessons/${type}/${id}/edit`,

  questions: {
    index: (id: param) => `/lessons/${type}/${id}/questions`,
    new: (id: param) => `/lessons/${type}/${id}/questions/new`,
    edit: (id: param, questionId: param) =>
      `/lessons/${type}/${id}/questions/${questionId}/edit`,
  },
})

// Auth routes
const AuthRoutes = {
  front: '/front',
  login: '/login',
  register: '/register',
  forgot_password: '/forgot-password',
  confirmation_link_sent: '/confirmation-link-sent',
  resend_link: '/resend-link',
  resend_link_sent: '/resend-link-sent',
}

// Common routes
const CommonRoutes = {
  messages: {
    index: '/messages',
  },
  settings: {
    index: '/settings',
  },
  notifications: {
    index: '/notifications',
  },
  favorites: {
    index: '/favorites',
  },
  invites: {
    index: '/invites',
  },
  marketplace: {
    index: '/marketplace',
  },
  billing: {
    index: '/billing',
  },
  profile: {
    index: '/profile',
  },
  timetable: {
    index: '/timetable',
    day: (date: string) => `/timetable/${date}`,
    new: (date: string) => `/timetable/${date}/new`,
    edit: (id: param) => `/timetable/${id}/edit`,
  },
  downloads: {
    index: '/downloads',
  },
  library: {
    index: '/library',
  },
}

// All routes
export const routes = {
  root: '/',

  ...AuthRoutes,
  ...CommonRoutes,

  children: {
    index: '/children',
    show: (id: param) => `/children/${id}`,
  },
  report_card: '/report-card',
  practices: resource('practices'),
  tests: resource('tests'),
  video: resource('video'),
  students: {
    index: '/students',
    show: (id: param) => `/students/${id}`,
  },
  classrooms: {
    index: '/classrooms',
    new: '/classrooms/new',
    edit: (id: param) => `/classrooms/${id}/edit`,
    students: (id: param) => `/classrooms/${id}/students`,
  },
  printables: {
    index: '/shop',
    new: '/shop/new',
    edit: (id: param) => `/shop/${id}/edit`,
  },
  public_lessons: {
    index: '/public-lessons',
    new: '/public-lessons/new',
    edit: (id: param) => `/public-lessons/${id}/edit`,
  },

  after_school: {
    index: '/after-school',
    games: {
      index: '/after-school/games',
    },
    reading: {
      index: '/after-school/reading',
    },
    videos: {
      index: '/after-school/videos',
    },
    chores: {
      index: '/after-school/chores',
    },
    sport: {
      index: '/after-school/sport',
    },
  },

  dashboard: {
    index: '/dashboard',
    day: (date: string) => `/dashboard/${date}`,
    report_card: {
      index: '/stats/report-card',
    },
    awards: {
      index: '/stats/awards',
    },
    teachers: {
      index: '/stats/teachers',
    },
    friends: {
      index: '/stats/friends',
    },
  },

  lessons: {
    index: '/lessons',
    new: '/lessons/new',
    late: '/lessons/late',
    history: '/lessons/history',
    queue: (id: param) => `/lessons/queue/${id}`,
  },
  playground: '/playground',
  draw: '/draw',

  homeworks: {
    index: '/homeworks',
    show: (id: param) => `/homeworks/${id}`,
  }
}
